<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import fetchData from '../api.js';
    import UserStore from '../stores/user';
    import { validateFields }  from '../base/validation.js';
    import { _ } from "svelte-i18n";
    import { onMount } from 'svelte';
    import Header from '../components/Header.svelte'; 
    import TopInfo from '../components/TopInfo.svelte';  
    import Preloader from '../components/Preloader.svelte'; 

    export let params;

    let customer_id = params.customer_id;

    let isLoading = false;

    let integrations = [];

    let platform = "1";

    let customer = {};

    let integration = {}

    const fetchPage = async() => {

        if (!$UserStore || !$UserStore.merchant_id){
            push('/login');
            return;
        } 


        getCustomer(customer_id)


    }


    fetchPage(); 


    async function getCustomer(customer_id) {

        let postData = {};

        postData.action = 'get_customer';
        postData.token = $UserStore.token
        postData.customer_id = customer_id;
        let response = await fetchData(postData);
        if (response.customer) {

            customer = response.customer;

            for(let key in customer.settings.integration) {

              let integration_temp = customer.settings.integration[key];               

              integration = {...integration_temp}
              integration[key] = 1
              integrations.push(integration)

            }

            integrations = [...integrations]


        }
    }



    async function handleSubmit() {

        isLoading = true;

        let postData = {};

        postData.action = 'update_customer_integrations';
        postData.token = $UserStore.token
        postData.integration = integrations;
        postData.customer_id = customer_id

        let response = await fetchData(postData);
        alert('הנתונים נשמרו בהצלחה')



        isLoading = false;


    }
    

    function addIntegration() {

        let temp = {};
        if (platform=="1") {
            temp.wordpress = 1;
        } else {
            temp.shopify = 1;
        }
       
        integrations.push(temp)
        integrations = integrations;
    }

    function removeIntegration(index) {

        if (confirm(`${$_('integrations.delete_confirmation')}`)) {

            integrations.splice(index, 1);
            integrations = integrations;
        }
        
    }
    
</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    <div class="page">    
        <TopInfo/>
        <div class="shipment p-5">            
            <h1 class="text-[20px] font-bold">
                {$_('integrations.title')}
            </h1>    
            <div class="flex items-center mt-5">
                <select bind:value={platform} class="w-[200px] rounded-e-[0px] py-[7px]">
                    <option value="1">Wordpress</option>
                    <option value="2">Shopify</option>
                </select>
                <div class="cursor-pointer text-center border-custom-border-blue bg-custom-bg-blue text-white px-4 py-2 rounded-[30px] rounded-s-[0px] w-[120px] text-enter" on:click={ ()=> addIntegration() }>{$_('integrations.add')}</div>
            </div>    
            <div class="shipment-flex">
                <div class="shipment_origin">                           
                    <div class="">
                        {#if !integrations.length}
                        <div class="mb-5 mt-5 bg-slate-100 border-slate-200 border-[1px] p-5 rounded-[5px]">                            
                            {$_('integrations.not_found')}
                        </div>
                        {/if}
                        <div>
                            {#each integrations as integration,index}
                            <div class="mt-5 text-[14px] border-[1px] border-slate-300 rounded-[5px] p-5 bg-slate-50">                                
                                <div class="mb-2 font-bold">
                                    {$_('integrations.website')} {index+1}
                                </div>
                                <div class="mb-2 flex items-center gap-2">                                    
                                    {#if integration.wordpress}
                                        <div><img src="images/wordpress.svg" class="w-[50px]"></div>
                                        <div>Wordpress</div>
                                    {/if}
                                    {#if integration.shopify}
                                        <div><img src="images/shopify.svg" class="w-[50px]"></div>
                                        <div>Shopify</div>
                                    {/if}
                                </div>
                                <div class="mb-2">
                                    <label for="url{index}">{$_('integrations.url')}</label>
                                    <input dir="ltr" class="text-left" id="url{index}" type="text" bind:value={integration.url}>
                                </div>
                                <div class="mb-2">
                                    <label for="key{index}">{$_('integrations.key')}</label>
                                    <input dir="ltr" class="text-left" id="key{index}" type="text" bind:value={integration.key}>
                                </div>
                                <div class="mb-2">
                                    <label for="secret{index}">{$_('integrations.secret')}</label>
                                    <input dir="ltr" class="text-left" id="secret{index}" type="text" bind:value={integration.secret}>
                                </div>
                                <div>
                                    <div class="cursor-pointer text-center border-custom-border-blue bg-custom-bg-blue text-white px-4 py-2 rounded-[30px]  w-[120px] text-enter" on:click={ ()=> removeIntegration(index) }>{$_('integrations.delete')}</div>
                                </div>
                            </div>
                            {/each}
                        </div>                        
                    </div>
                </div> 
            </div> 
            {#if integrations.length}
            <div class="shipment-flex-button fixed bottom-[20px] z-1 left-0 right-0 m-auto">
                <div class="cursor-pointer box-shadow border-custom-border-blue bg-custom-bg-blue text-white px-4 py-2 rounded-[30px] w-[200px] m-auto text-center" on:click={ ()=>handleSubmit() }>{$_('integrations.save')}</div>
            </div>
            {/if} 
        </div>
        
    </div>
</div>

